
namespace RioERP.Invoices {

    @Serenity.Decorators.registerClass()
    export class InvoicesGrid extends Serenity.EntityGrid<InvoicesRow, any> {
        protected getColumnsKey() { return InvoicesColumns.columnsKey; }
        protected getDialogType() { return InvoicesDialog; }
        protected getIdProperty() { return InvoicesRow.idProperty; }
        protected getInsertPermission() { return InvoicesRow.insertPermission; }
        protected getLocalTextPrefix() { return InvoicesRow.localTextPrefix; }
        protected getService() { return InvoicesService.baseUrl; }
        public rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);
            buttons.push({
                title: 'Print Invoice',
                cssClass: 'print-button',
                onClick: () => {
                    //debugger;
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length != 1) {
                        Q.alert("Please select single Order(s) to print Receipt");
                        return;
                    }
                    else {
                        var param = {
                            'InvoiceId': rowKeys
                        };

                        //this.OpenWindowWithPostData(url, "", "PrintLabels", param);
                        //window.location.href = Q.resolveUrl('~/PrintInvoice/PrintInvoiceDetail?InvoiceId=' + rowKeys[0]);

                        Q.postToService({ url: Q.resolveUrl('~/PrintInvoice/PrintInvoiceDetail?InvoiceId=' + rowKeys[0]), request: '', target: '_blank' });
                    }
                }
            });
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: InvoicesService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            return buttons;
        }
        protected getItemCssClass(item: Invoices.InvoicesRow, index: number): string {
            let klass: string = "";
            /*if (item.PaymentMode == RioERP.Web.Enums.PaymentMode.CashOnDelivery)
                klass += " cashondelivery";
            else {*/
            if (item.EInvoiceStatus == RioErp.Web.Enums.InvoiceStatus.Confirmed)
                klass += " confirmed";
            else if (item.EInvoiceStatus == RioErp.Web.Enums.InvoiceStatus.Cancelled)
                klass += " cancelled";


            return Q.trimToNull(klass);
        }
    }
}